import { Component } from '@angular/core';
import { TemplateService } from '../../service/template.service';

@Component({
  selector: 'app-footer-controler',
  templateUrl: './footer-controler.component.html',
  styleUrls: ['./footer-controler.component.scss']
})
export class FooterControlerComponent {
  showFooter: boolean;

  constructor(
    private templateService: TemplateService,
  ) { }

  toggle() {
    this.showFooter = !this.showFooter;
    this.templateService.updateFatFooterStatus(this.showFooter);
  }
}
